// src/pages/PainelChamados/FormularioChamado.jsx
import { X, ClipboardList } from "lucide-react";
import CamposFormulario from "./CamposFormulario";
import CampoEmpresa from "./CampoEmpresa";
import CampoResponsavel from "./CampoResponsavel";
import CampoRelatoSolucao from "./CampoRelatoSolucao";
import Menu from "./Menu";

import { useState } from "react";

export default function FormularioChamado({ onVoltar, onSalvo }) {
  const [filtroCliente, setFiltroCliente] = useState("");
  const [colaborador, setColaborador] = useState("");
  const [tecnicoResponsavel, setTecnicoResponsavel] = useState("");
  const [relatoProblema, setRelatoProblema] = useState("");
  const [solucaoProblema, setSolucaoProblema] = useState("");
  const [status, setStatus] = useState("");

  // 🔹 Estados controlados
  const [tipoServico, setTipoServico] = useState("");
  const [finalizadoEm, setFinalizadoEm] = useState("");

  return (
    <div
      className="bg-white rounded-md shadow-sm h-full flex flex-col"
      style={{ border: "1px solid #2b2b2b" }}
    >
      {/* Cabeçalho */}
      <div
        className="flex items-center justify-between px-4 py-3"
        style={{ backgroundColor: "#2b2b2b" }}
      >
        <div className="flex items-center gap-2">
          <ClipboardList size={20} className="text-white" />
          <h2 className="text-lg font-semibold text-white">
            Realizando cadastro de chamado
          </h2>
        </div>
        <button
          onClick={onVoltar}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-white text-black transition transform hover:scale-110 hover:bg-slate-200"
          aria-label="Fechar formulário"
        >
          <X size={16} />
        </button>
      </div>

      {/* Conteúdo */}
      <div className="flex flex-1 overflow-hidden">
        {/* Formulário */}
        <div className="flex-1 p-6 overflow-y-auto space-y-6">
          <CamposFormulario
            tipoServico={tipoServico}
            setTipoServico={setTipoServico}
            finalizadoEm={finalizadoEm}
            setFinalizadoEm={setFinalizadoEm}
          />

          <div className="flex flex-wrap gap-6 mb-6 mt-4">
            <CampoEmpresa
              filtroCliente={filtroCliente}
              setFiltroCliente={setFiltroCliente}
            />

            <CampoResponsavel
              colaborador={colaborador}
              setColaborador={setColaborador}
              tecnicoResponsavel={tecnicoResponsavel}
              setTecnicoResponsavel={setTecnicoResponsavel}
            />
          </div>

          <CampoRelatoSolucao
            relato={relatoProblema}
            setRelato={setRelatoProblema}
            solucao={solucaoProblema}
            setSolucao={setSolucaoProblema}
          />
        </div>

        {/* Menu lateral */}
        <div className="w-40 border-l border-slate-300 bg-gray-50 flex flex-col p-4">
          <Menu
            colaborador={colaborador}
            tecnicoResponsavel={tecnicoResponsavel}
            relatoProblema={relatoProblema}
            solucaoProblema={solucaoProblema}
            filtroCliente={filtroCliente}
            status={status}
            tipoServico={tipoServico}
            setStatus={setStatus}
            finalizadoEm={finalizadoEm}
            setFinalizadoEm={setFinalizadoEm}
            onCancelar={onVoltar}
            onFinalizar={() => console.log("Finalizar")}
            onAtribuir={() => console.log("Atribuir")}
            onSalvo={onSalvo}
          />
        </div>
      </div>
    </div>
  );
}
